module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header",
    class: {
      BAM: _vm.isBAM
    },
    attrs: {
      "id": "headerRippleWrap"
    }
  }, [_c('h1', {
    staticClass: "iconfont icon-fepawn",
    on: {
      "click": function($event) {
        return _vm.changeHash('blog')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headerR"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsShow),
      expression: "searchIsShow"
    }],
    staticClass: "search",
    class: {
      active: _vm.slideDown
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": _vm.showSearch
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInfo),
      expression: "searchInfo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入搜索内容回车"
    },
    domProps: {
      "value": (_vm.searchInfo)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.searchSubmit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInfo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.userID) ? _c('div', {
    staticClass: "logout ripple",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "iconfont icon-git46"
  }), _vm._v(" "), _c('span', {
    staticClass: "Tooltip"
  }, [_vm._v("退出")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "person",
    class: {
      activeType: _vm.activeRoute.indexOf('/BAM') > -1
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('BAM')
      }
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "Tooltip"
  }, [_vm._v("个人中心")])])]), _vm._v(" "), _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navListIsShow),
      expression: "navListIsShow"
    }]
  }, [_c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/blog' || _vm.activeRoute === '/article'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('blog')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-home1149866easyiconnet"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("博客")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/time'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('time')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-emizhifeiji"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("归档")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/code'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('code')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-insert_tag_field"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("代码段")]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4c3bca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 276
// module chunks = 1